import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import workspaceImage from "@assets/images/group/workspace.svg";
import { Group } from "@domain/group/group";
import { BackgroundImage } from "@ui/components/backgroundImage";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { stack } from "@ui/components/layout";
import { useModalTools } from "@ui/modals/modalContext";
import { SpacesLimitModal } from "./spacesLimitModal";
import { WorkspaceEditor } from "./workspaceEditor";

interface CreateWorkspaceThumbnailProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
	limitReached?: boolean;
}
export const CreateWorkspaceThumbnail: React.FC<CreateWorkspaceThumbnailProps> = ({
	shareroom,
	limitReached,
	...htmlProps
}) => {
	const { createModal } = useModalTools();

	return (
		<Container {...htmlProps}>
			<BackgroundImage defaultUrl={workspaceImage}>
				<PrimaryButton
					onClick={() =>
						createModal((close) =>
							limitReached ? (
								<SpacesLimitModal close={close} />
							) : (
								<WorkspaceEditor close={close} shareroom={shareroom} />
							)
						)
					}
				>
					{I18n.t("workspace.create")}
				</PrimaryButton>
			</BackgroundImage>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	overflow: hidden;
	> :first-child {
		width: 100%;
		height: 100%;
	}

	.content {
		padding: 36px 32px;
		${stack(0, "flex-end", "center")};
	}
`;
